
import Busqueda from '../pages/Busqueda'
import BusequedaDetalles from '../pages/BusquedaDetalles'
import Home from '../pages/Home'

import BusquedaLicencias from '../pages/BusquedaLicencias'
import BusquedaLicenciaDetalle from '../pages/BusquedaLicenciasDetalles'

import BusquedaPredial from '../pages/BusquedaPredial'
import BusquedaPredialDetalle from '../pages/BusquedaPredialDetalle'

import BusquedaImpuestos from '../pages/BusquedaImpuestos'
import BusquedaImpuestosDetalles from '../pages/BusquedaImpuestosDetalles'

import BusquedaCivil from '../pages/BusquedaCivil'
import BusquedaCivilDetalles from '../pages/BusquedaCivilDetalles'


import BusquedaGeneral from '../pages/BusquedaGeneral'
import BusquedaRpp from '../pages/BusquedaRpp'
import BusquedaRppDetalles from '../pages/BusquedaRppDetalles'
import Login from '../pages/Login'
import NewPassword from '../pages/NewPassword'; 


//layouts
import LayoutDefault from '../layouts/LayoutDefault'

import Layoutlogin from '../layouts/Layoutlogin'



const routes = [


    {

        
        path:"/",
        component:Home,
        layout:LayoutDefault
        
    },
    {

        
        path:"/new-password",
        component: NewPassword,
        layout:LayoutDefault
        
    },
    {


        path:"/sign-in",
        component:Login,
        layout:Layoutlogin
        
    },
    {
        path:"/busqueda",
        component:Busqueda,
        layout:LayoutDefault
    },
    {
        path:"/detalles/:id",
        component:BusequedaDetalles,
        layout:LayoutDefault
    },


    {
        path: "/busqueda-licencias",
        component: BusquedaLicencias,
        layout:LayoutDefault
    },
    {
        path:"/licencias-detalles/:id",
        component: BusquedaLicenciaDetalle,
        layout:LayoutDefault
    },


    {
        path: "/busqueda-predial",
        component: BusquedaPredial,
        layout:LayoutDefault
    },
    {
        path:"/predial-detalles/:id",
        component: BusquedaPredialDetalle,
        layout:LayoutDefault
    },


    {
        path: "/busqueda-impuestos",
        component: BusquedaImpuestos,
        layout:LayoutDefault
    },
    {
        path:"/impuestos-detalles/:id",
        component: BusquedaImpuestosDetalles,
        layout:LayoutDefault
    },
    {
        path:"/busqueda-civil",
        component:BusquedaCivil,
        layout:LayoutDefault
    },
    {
        path:"/civil-detalles/:id",
        component:BusquedaCivilDetalles,
        layout:LayoutDefault
    },
    {
        path:"/busqueda-rpps",
        component:BusquedaRpp,
        layout:LayoutDefault
    },
    {
        path:"/Rpp-detalles/:id",
        component:BusquedaRppDetalles,
        layout:LayoutDefault
    },
    {
        path:"/busqueda-general",
        component:BusquedaGeneral,
        layout:LayoutDefault
    },
 
    
]


export default routes;

